import { FooterLinks, NavbarLinks } from '@/constants/navbar';
import { Copyright, FacebookIcon, InstagramIcon, TwitterIcon, YoutubeIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import SubscribeNewsLetter from '../home/SubscribeNewsLetter';
export const Footer = () => {
  let navigate = useNavigate();
  return (
    <div className="relative mt-[4rem] flex w-full flex-wrap items-center justify-center overflow-hidden px-[1rem] font-inter">
      <SubscribeNewsLetter />
      <div className="relative w-full max-w-[114rem]">
        <div className="z-[1] mt-[4rem] flex w-full flex-wrap items-center justify-center gap-[3rem] md:flex-nowrap md:justify-between">
          <div className="flex w-full flex-wrap items-center justify-center gap-[0.5rem] md:w-[13rem] md:justify-start">
            <img alt="ico" className="h-auto w-[13rem]" src="/favicon.png" />
            <h1
              style={{ fontFamily: 'PT Serif, serif' }}
              className="ml-[-0.1rem] mt-[-0.5rem] w-full text-center text-[1.4rem] font-[600] text-white md:ml-[0.2rem] md:text-left"
            >
              NEXT-G SERVICES
            </h1>
          </div>
          <div className="flex items-center justify-center gap-y-[1rem] sm:justify-start md:gap-x-[4rem]">
            <div className="flex flex-row flex-wrap items-stretch justify-center gap-x-[2rem] gap-y-[2rem] text-[1.6rem] sm:gap-x-[2rem] md:justify-start lg:gap-x-[6rem]">
              {FooterLinks.map((item, index) => (
                <div key={index} className="hover group">
                  {' '}
                  <p
                    onClick={() => {
                      navigate(item.link);
                    }}
                    key={item}
                    className="cursor-pointer text-[1.4rem] font-[500] text-white transition-colors duration-300 hover:text-[#0EC9AC]"
                  >
                    {item.label}
                  </p>
                </div>
              ))}
            </div>
          </div>
          {/* <div className="flex flex-row flex-wrap items-stretch justify-center gap-[3rem] text-[1.6rem] md:justify-start">
            <div className="flex h-[4rem] w-[4rem] items-center justify-center rounded-full bg-[#0EC9AC] text-white">
              <FacebookIcon />
            </div>
            <div className="flex h-[4rem] w-[4rem] items-center justify-center rounded-full bg-[#0EC9AC] text-white">
              <InstagramIcon />
            </div>
            <div className="flex h-[4rem] w-[4rem] items-center justify-center rounded-full bg-[#0EC9AC] text-white">
              <TwitterIcon />
            </div>
            <div className="flex h-[4rem] w-[4rem] items-center justify-center rounded-full bg-[#0EC9AC] text-white">
              <YoutubeIcon />
            </div>
          </div> */}
        </div>
      </div>
      <div className="z-[66666] mt-[4rem] flex h-[9rem] w-full items-center justify-center px-[2rem]">
        <div className="flex w-full max-w-[114rem] flex-wrap items-center justify-center gap-[1rem] md:justify-between">
          {/* <p className="cursor-pointer text-[1.4rem] font-[600] leading-[3rem] text-[#DDDDDD] md:text-[1.6rem] md:font-[500]">
            <span
              onClick={() => {
                navigate('/privacy-policy');
              }}
              className="duration-3 transition-colors hover:text-[#0EC9AC]"
            >
              {' '}
              Privacy & Policy{' '}
            </span>{' '}
            &nbsp;&nbsp;
            <span
              onClick={() => {
                navigate('/terms-conditions');
              }}
              className="duration-3 transition-colors hover:text-[#0EC9AC]"
            >
              {' '}
              Terms & Conditions
            </span>
          </p> */}
          <div className="flex w-full flex-row items-center justify-center gap-[0.4rem] text-[1.6rem] font-[400] text-[#DDDDDD]">
            <Copyright strokeWidth={2} size={'1.4rem'} className="text-[1.4rem] text-white" />
            <p className="text-center text-[1.4rem] font-[600] leading-[100%] md:text-[1.6rem] md:font-[500]">
              Copyright {new Date().getFullYear()} . All Rights Reserved
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
